module.exports = __webpack_public_path__ + "img/backpack.4f7e03a1.jpg";